// extracted by mini-css-extract-plugin
export default {"root":"Radio-module__root","checked":"Radio-module__checked"};